import { __decorate } from "tslib";
import { property, query, state } from 'lit/decorators.js';
import { html, LitElement, nothing } from 'lit';
import '../../atom/label/element';
import { dropDownDialogStyles } from './syles';
export class DropdownDialog extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
        this.focused = false;
        this.focusIndex = -1;
        this.preventClosing = (event) => {
            event.stopPropagation();
        };
        this.clickHeader = () => {
            if (this.hasAttribute('disabled')) {
                return;
            }
            if (this.hasAttribute('active')) {
                this.removeAttribute('active');
                return;
            }
            document.addEventListener('click', this.closeWithClick);
            this.setAttribute('active', '');
            setTimeout(() => {
                this.active = true;
            }, 0);
        };
        this.handleKeyDown = (e) => {
            if (this.hasAttribute('disabled')) {
                return;
            }
            switch (e.key) {
                case ' ':
                    this.focused ? this.closeWithClick() : this.clickHeader();
                    this.focused = !this.focused;
                    break;
                case 'Escape':
                case 'Tab':
                    this.focused && this.closeWithClick();
                    this.focused = false;
                    break;
            }
        };
        this.closeWithClick = () => {
            if (this.active) {
                this.removeAttribute('active');
                this.active = false;
                document.removeEventListener('click', this.closeWithClick);
            }
        };
    }
    render() {
        return html `
            <div class="header" @click="${this.clickHeader}">${this.label ? html ` <ep-label>${this.label}</ep-label> ` : nothing}</div>
            <div class="body" @click="${this.preventClosing}">
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        !this.getAttribute('tabindex') && this.setAttribute('tabindex', '1');
        this.addEventListener('keydown', this.handleKeyDown);
    }
}
DropdownDialog.styles = [dropDownDialogStyles];
__decorate([
    property()
], DropdownDialog.prototype, "value", void 0);
__decorate([
    property()
], DropdownDialog.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], DropdownDialog.prototype, "disabled", void 0);
__decorate([
    state()
], DropdownDialog.prototype, "active", void 0);
__decorate([
    state()
], DropdownDialog.prototype, "focused", void 0);
__decorate([
    state()
], DropdownDialog.prototype, "focusIndex", void 0);
__decorate([
    query('slot[name=body]')
], DropdownDialog.prototype, "slotBody", void 0);
__decorate([
    query('ep-label')
], DropdownDialog.prototype, "labelElement", void 0);
__decorate([
    query('.value')
], DropdownDialog.prototype, "valueHeader", void 0);
if (!customElements.get('ep-dropdown-dialog')) {
    customElements.define('ep-dropdown-dialog', DropdownDialog);
}
//# sourceMappingURL=element.js.map